import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import BarLoader from "react-spinners/BarLoader";
import { Image } from "hesus-ui-kit";
import PersonDetail from "./components/PersonDetail/PersonDetail";
import editIcon from "@icons/ic-edit-blue.svg";
import salesIcon from "@icons/ic-sales.svg";
import financeIcon from "@icons/ic-finance1.svg";
import studiesIcon from "@icons/ic-studies.svg";
import productsIcon from "@icons/ic-products1.svg";
import dispatchIcon from "@icons/ic-dispatch.svg";
import clientIcon from "@icons/ic-client.svg";
import PersonInChargeAddEdit from "../PersonInChargeAddEdit/PersonInChargeAddEdit";
import {
  GenrealInfo,
  Title,
  GridRow,
  ButtonWrapper,
  PaddingDiv,
} from "./PersonInChargeList.styled";
import "./PersonInChargeList.scss";

const PersonInChargeList = (props) => {
  const { t, objectId, objectType, columnName, data, editOption, countryId } =
    props;

  const [loading, setLoading] = useState(false);
  const [personData, setPersonData] = useState([]);

  const [isAddEditPopupVisible, setAddEditPopupVisible] = useState(false);

  useEffect(() => {
    if (!data && objectId) {
      setLoading(true);
      axios
        .get(`/personsInCharge?${columnName}=${objectId}`)
        .then((response) => {
          setPersonData(response?.data);
          setLoading(false);
        })
        .catch((error) => handleApiError(error));
    } else {
      setPersonData(data);
    }
  }, [data]);

  const onEdit = () => {
    setAddEditPopupVisible(true);
  };

  const closePersonInChargePopup = () => {
    setAddEditPopupVisible(false);
  };
  return (
    <GenrealInfo>
      {loading && <BarLoader width="100%" color="#1bace4" />}
      {editOption && (
        <GridRow column="1fr 1fr">
          <Title>{t("PERSON_IN_CHARGE")}</Title>
          <ButtonWrapper>
            <Image
              src={editIcon}
              onClick={onEdit}
              alt={t("PERSON_IN_CHARGE_ACTION_TOOLTIP_EDIT")}
              title={t("PERSON_IN_CHARGE_ACTION_TOOLTIP_EDIT")}
              className="personInCharge-list__image-icon"
            />
          </ButtonWrapper>
        </GridRow>
      )}
      {personData && (
        <PaddingDiv>
          <GridRow column="1fr 1fr 1fr" marginBottom="20px">
            <PersonDetail
              data={personData.sales}
              personIcon={salesIcon}
              iconTitle={t("TEAM_SALES")}
            />
            <PersonDetail
              data={personData.studies}
              personIcon={studiesIcon}
              iconTitle={t("TEAM_STUDIES")}
            />
            <PersonDetail
              data={personData.finance}
              personIcon={financeIcon}
              iconTitle={t("TEAM_FINANCE")}
            />
          </GridRow>
          <GridRow column="1fr 1fr 1fr" marginBottom="20px">
            <PersonDetail
              data={personData.products}
              personIcon={productsIcon}
              iconTitle={t("TEAM_PRODUCTS")}
            />
            <PersonDetail
              data={personData.operations}
              personIcon={dispatchIcon}
              iconTitle={t("TEAM_OPERATIONS")}
            />
            <PersonDetail
              data={personData.customerRelationship}
              personIcon={clientIcon}
              iconTitle={t("TEAM_CUSTOMER_RELATIONSHIP")}
            />
          </GridRow>
        </PaddingDiv>
      )}
      {isAddEditPopupVisible && (
        <PersonInChargeAddEdit
          title={t("Contact")}
          onClose={closePersonInChargePopup}
          entityId={objectId}
          entityType={objectType}
          data={personData}
          setData={setPersonData}
          columnName={columnName}
          countryId={countryId}
        />
      )}
    </GenrealInfo>
  );
};

PersonInChargeList.propTypes = {
  t: PropTypes.func.isRequired,
  objectId: PropTypes.number.isRequired,
  objectType: PropTypes.string.isRequired,
  columnName: PropTypes.string.isRequired,
  data: PropTypes.shape([{}]),
  editOption: PropTypes.bool,
  countryId: PropTypes.number.isRequired,
};

PersonInChargeList.defaultProps = {
  data: null,
  editOption: true,
};

export default withTranslation()(PersonInChargeList);
